<template>
    <modal @close="$emit('close')" :autoshow="true" ref="modal" :is-closeable="isCloseable">
        <template v-slot:title>Edit Employee Phone</template>

        <template v-slot:subheading>
            <div class="p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Employee:</span> {{ employee.full_name }}</div>
                <div><span class="text-muted">Company:</span> {{ employee.company.name }}</div>
            </div>
        </template>

        <slot>
            <div>
                <form>
                    <form-errors :errors="formErrors"/>

                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Phone" v-model="formData.phone_home" :errors="errors.phone_home" type="phone" />
                        </div>
                    </div>
                </form>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit">Save</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/ModalMixin'
import FormMixin from '@/mixins/Form'

export default {
    mixins: [ModalMixin, FormMixin],
    components: {},
    props: ['client', 'employee', ],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    methods: {
        makeFormData() {
            return {
                phone_home: this.employee.phone_home,
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            this.errors = {}
            this.formErrors = []
            this.$api.patch(`/clients/${this.client.id}/employees/${this.employee.id}/phone`, this.getFormData()).then(resp => {
                this.$emit('updated')
                this.close()
            }).catch(errors => {
                this.errors = errors
                this.formErrors = errors.__all__
            })
        },
    }
}
</script>
